import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import {
  removeOperation,
  removeAllOperations,
  operationsDeselected,
  sectionsDeselected,
} from 'store/entities/activity-model/activity-model';
import { selectActivityModelLoaders } from 'store/entities/activity-model/selectors';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const OperationDeleteModal = ({
  setModalVisible,
  removeOperation,
  operationId,
  setActiveForm,
  operationsDeselected,
  removeAllOperations,
  projectId,
  isDeleting,
  sectionsDeselected,
}) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    if (operationId) {
      removeOperation(operationId, { projectId });
    } else {
      removeAllOperations(projectId);
    }

    setModalVisible(isDeleting);
    setActiveForm(null);
    operationsDeselected();
    sectionsDeselected();
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(
            operationId ? translations.activityModel_deleteOperation : translations.activityModel_deleteOperations,
          ),
          content: (
            <>
              {t(
                operationId
                  ? translations.activityModel_areYouSureYouWantToDeleteThisOperation
                  : translations.activityModel_areYouSureYouWantToDeleteAllOperations,
              )}
            </>
          ),
          footer: (
            <>
              <Button
                testId="delete-modal-button-delete"
                label={t(translations.delete)}
                colored
                loading={isDeleting}
                disabled={isDeleting}
                onClick={onDelete}
              />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { isDeleting } = selectActivityModelLoaders(state);
  return {
    isDeleting,
  };
};

const mapDispatchToProps = {
  removeOperation,
  operationsDeselected,
  removeAllOperations,
  sectionsDeselected,
};
const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(OperationDeleteModal), {
  isModal: true,
});

export { Container as OperationDeleteModal };
